import { render, staticRenderFns } from "./TBody.vue?vue&type=template&id=1701d930"
import script from "./TBody.vue?vue&type=script&lang=js"
export * from "./TBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports